var React = require( 'react' );
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var Link = require('react-router').Link;
var FBLoginButton = require('../../../components/fbLoginButton.jsx');
var LinkWrapper = require('../../../components/linkWrapper.jsx')(Link);

var DownloadPdf = createReactClass({
        mixins: [PureRenderMixin],

        handleRegisterClick: function(event){
            event.preventDefault();
            this.props.showModal('MODAL_TYPE_REGISTER');
        },

        handleLoginClick: function(event){
            event.preventDefault();
            this.props.showModal('MODAL_TYPE_LOGIN');
        },

        handleClickTracking: function(e) {
            var currentTarget = e.currentTarget;
            var action = currentTarget.innerText;
            var label = currentTarget.href;
            this.props.clickTracking(action, label);
        },

        render: function(){
            return (
               <div className="download-pdf">
                   <div className="file-thumbnail">
                       <span className="thumbnail-wrap"><img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/file-thumbnail_2x.png" alt="" /></span>
                       <span className="file-type-badge"><img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/icon-pdf_2x.png" alt="" />PDF</span>
                   </div>
                   <p className="tit">This article is available for download in PDF format.</p>
                   {!this.props.isLogin && (
                       <p className="tip">Register or login below to download immediately.</p>
                   )}
                   {this.props.isLogin && (
                       <p className="tip">Click the button below to download it immediately. </p>
                   )}
                   <div className="button-wrapper">
                       {!this.props.isLogin && (
                           <FBLoginButton
                               authFacebook={this.props.authFacebook}
                               loginRedirectUrl="no-redirect"
                               label="Continue with Facebook"
                               analyticsLabelSuffix="download pdf" />
                       )}
                       {this.props.isLogin && (
                           <a className="button" href={this.props.file} target="_blank" rel="noopener noreferrer" onClick={this.handleClickTracking}><span className="ion-ios-download-outline"></span> Download this PDF now</a>
                       )}
                   </div>
                   {!this.props.isLogin && (
                       <p><LinkWrapper to="/register" onClick={this.handleRegisterClick} handler={this.props.clickTracking}>Sign Up via Email</LinkWrapper> <span className="split">|</span> Existing user? <LinkWrapper to="/login" onClick={this.handleLoginClick} handler={this.props.clickTracking}>Login here</LinkWrapper></p>
                   )}
               </div>
            )
        }
});

module.exports = DownloadPdf;



// WEBPACK FOOTER //
// ./src/common/routes/education/components/layout/downloadPdf.jsx